export const furnitureCollectionData = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/dhttnehwp/image/upload/v1731801894/House/sp3ego5rdz0m7tk9nfgf.png",
    title: "Classic Wooden Chair",
    description:
      "A beautifully crafted wooden chair made from premium oak wood. Designed for elegance and durability, it's perfect for homes, offices, or traditional spaces. A timeless addition to any decor.",
    discounts: "MIN 50 % Discount On All Products",
    category: "Wood Chair",
    properties: [
      { key: "Material", value: "Made from premium quality oak wood" },
      { key: "Weight Capacity", value: "Can hold up to 120 kilograms" },
      { key: "Color", value: "Natural brown with a glossy finish" },
      { key: "Dimensions", value: "Eighteen by eighteen by thirty-six inches" },
      { key: "Style", value: "Designed for a classic vintage look" },
    ],
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/dhttnehwp/image/upload/v1731801884/House/slf45bzcglkajthaxahi.png",
    title: "Plastic Lounge Chair",
    description:
      "A comfortable lounge chair crafted from high-quality plastic. Lightweight yet sturdy, it's ideal for indoor or outdoor spaces. Offers a sleek design that complements modern living areas.",
    discounts: "MIN 30 % Discount On All Products",
    category: "Plastic Chair",
    properties: [
      { key: "Material", value: "High-quality durable plastic material used" },
      { key: "Weight Capacity", value: "Supports weight up to 100 kilograms" },
      { key: "Color", value: "Bright white color with smooth texture" },
      {
        key: "Dimensions",
        value: "Twenty by twenty-two by thirty-four inches",
      },
      { key: "Style", value: "Perfect for a contemporary stylish look" },
    ],
  },
  {
    id: 3,
    image:
      "https://res.cloudinary.com/dhttnehwp/image/upload/v1731801890/House/nytnhpgqwaqcgqqqrce7.png",
    title: "Luxury Leather Sofa",
    description:
      "An elegant leather sofa crafted from premium materials. Its modern design blends luxury and functionality, making it the ideal centerpiece for living rooms. Comfort and style redefined.",
    discounts: "MIN 20 % Discount On All Products",
    category: "Sofa Collection",
    properties: [
      { key: "Material", value: "Crafted from genuine top-grain leather" },
      {
        key: "Seating Capacity",
        value: "Comfortably seats up to three people",
      },
      { key: "Color", value: "Available in luxurious black leather color" },
      { key: "Dimensions", value: "Eighty by thirty-five by thirty inches" },
      { key: "Style", value: "Modern luxury with elegant craftsmanship" },
    ],
  },
];
